import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=266268ec&scoped=true&"
import script from "./QuoteCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteCard.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteCard.vue?vue&type=style&index=0&id=266268ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266268ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/circleci/app/components/storyblok/Header.vue').default})
